export let hres6oeColumns = () => {
  let custNewLatLngColumns = [{
    key: 'codcust',
    name: '',
    labelCodapp: 'HRES6OEC3',
    labelIndex: '20',
    class: 'align-center',
    style: 'min-width: 100px;'
  }, {
    key: 'namcust',
    name: '',
    labelCodapp: 'HRES6OEC3',
    labelIndex: '30',
    style: 'min-width: 200px;'
  }, {
    key: 'address',
    name: '',
    labelCodapp: 'HRES6OEC3',
    labelIndex: '40',
    style: 'min-width: 200px;'
  }]

  return {
    en: {
      custNewLatLng: custNewLatLngColumns
    },
    th: {
      custNewLatLng: custNewLatLngColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6oe.js